// Module
var code = "<support-was-this-useful class=\"btpg-wtu\" contact-support-url=\"$ctrl.contactSupportUrl\" item-link=\"$ctrl.wtuItemLink\" ng-show=\"$ctrl.visible\" reset-on-changes=\"true\" sitecore-id=\"$ctrl.stepId\"> </support-was-this-useful> ";
// Exports
module.exports = code;